import PropTypes from 'prop-types';
import React from 'react';
import {
  trackAnalyticsClick,
  watchAnalyticsImpression,
} from 'js/analytics/metrics/analyticsTracking';

export class MoreButton extends React.Component {
  static propTypes = {
    onClick: PropTypes.func.isRequired,
    trackingTable: PropTypes.string,
  };

  impressionRef = (element) => {
    if (element === this.impressionElement) return;
    this.impressionWatcher?.stop();
    this.impressionWatcher = null;
    this.impressionElement = element;
    if (element && this.props.trackingTable) {
      this.impressionWatcher = watchAnalyticsImpression(
        element,
        'analytics-show-more',
        this.props.trackingTable,
        { table: this.props.trackingTable },
      );
    }
  };

  componentWillUnmount() {
    this.impressionWatcher?.stop();
  }

  handleClick = () => {
    if (this.props.trackingTable) {
      trackAnalyticsClick('analytics-show-more', {
        table: this.props.trackingTable,
      });
    }
    this.props.onClick();
  };

  render() {
    return (
      <div
        className="u-taCenter u-clickable u-bgColorGrayLightest u-p2x"
        ref={this.props.trackingTable ? this.impressionRef : undefined}
        style={{
          borderBottomLeftRadius: '4px',
          borderBottomRightRadius: '4px',
        }}
        onClick={this.handleClick}
      >
        <a
          className="u-p2x u-tcGrayDark u-fw500 u-letterSpacing1 u-textUppercase"
          style={{ fontSize: '10px' }}
        >
          Show More
        </a>
      </div>
    );
  }
}
